export const labels = {
  APP: 'Spot Probe',
  LOGIN: 'Login',
  HOME: 'Home',
  EMAIL: 'Email',
  PASSWORD: 'Password',
  PROCEED: 'Proceed',
};

export const clauses = {
  ENTER_EMAIL: 'your email...',
  ENTER_PASSWORD: 'your password...',
};

export const globals = {
  TOAST_TIMER: 3000
};

export const ROLES = {
  PLAYER: 'player',
  GROUND_ADMIN: 'ground_admin',
  ADMIN: 'admin',
}

export const ROLE_DISPLAY = {
  [ROLES.PLAYER]: 'Player',
  [ROLES.GROUND_ADMIN]: 'Ground Admin',
  [ROLES.ADMIN]: 'Admin',
}

export const ADMIN_ROLE_DISPLAY = {
  [ROLES.GROUND_ADMIN]: 'Ground Admin',
  [ROLES.ADMIN]: 'Admin',
}

export const ADMIN_PERMISSIONS = {
  USERS: 'users',
  ROLES: 'roles',
  APPROVALS: 'approvals',
  REPORTS: 'reports',
  ANALYTICS: 'analytics',
  WITHDRAWALS: 'withdrawals',
}

export const GROUND_ADMIN_PERMISSIONS = {
  GROUNDS: 'grounds',
  SLOTS: 'slots',
  BOOKINGS: 'bookings',
  EARNING: 'earning',
  WITHDRAW: 'withdraw',
  NOTIFICATIONS: 'notifications',
  OFFLINE_BOOKINGS: 'offline_bookings',
  MAINTENANCE: 'maintenance',
}

export const SUBROLES = {
  SUPER_ADMIN: 'super_admin',
  CONTENT_MODERATOR: 'content_moderator',
  SUPPORT_AGENT: 'support_agent',
  FINANCE_MANAGER: 'finance_manager',
  GROUND_MANAGER: 'ground_manager',
  BOOKING_MANAGER: 'booking_manager',
}

export const SUBROLE_DISPLAY = {
  [SUBROLES.SUPER_ADMIN]: 'Super Admin',
  [SUBROLES.CONTENT_MODERATOR]: 'Content Moderator',
  [SUBROLES.SUPPORT_AGENT]: 'Support Agent',
  [SUBROLES.FINANCE_MANAGER]: 'Finance Manager',
  [SUBROLES.GROUND_MANAGER]: 'Ground Manager',
  [SUBROLES.BOOKING_MANAGER]: 'Booking Manager',
}

export const APPROVAL_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
}

export const APPROVAL_STATUS_LABEL = {
  [APPROVAL_STATUS.PENDING]: 'Pending',
  [APPROVAL_STATUS.APPROVED]: 'Approved',
  [APPROVAL_STATUS.REJECTED]: 'Rejected',
}


export const BOOKING_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  DECLINED: 'declined',
}

export const BOOKING_STATUS_LABEL = {
  [BOOKING_STATUS.PENDING]: 'Pending',
  [BOOKING_STATUS.CONFIRMED]: 'Confirmed',
  [BOOKING_STATUS.CANCELLED]: 'Cancelled',
  [BOOKING_STATUS.COMPLETED]: 'Completed',
  [BOOKING_STATUS.DECLINED]: 'Declined',
}

export const PAYMENT_METHOD = {
  PAY_ONLINE: 'pay_online',
  PAY_AT_GROUND: 'pay_at_ground'
}

export const PAYMENT_METHOD_LABEL = {
  [PAYMENT_METHOD.PAY_ONLINE]: 'Pay Online',
  [PAYMENT_METHOD.PAY_AT_GROUND]: 'Pay At Ground'
}

export const CURRENCY = 'PKR';